import { type PropsWithChildren, type ComponentType } from 'react'

type ConditionalWrapperProps<WrapperProps extends PropsWithChildren = PropsWithChildren> =
  PropsWithChildren<{
    condition?: boolean
    wrapper?: ComponentType<WrapperProps>
    wrapperProps?: Omit<WrapperProps, 'children'>
  }>

export const ConditionalWrapper = <WrapperProps extends PropsWithChildren = PropsWithChildren>({
  children,
  wrapper: Wrapper,
  condition,
  wrapperProps
}: ConditionalWrapperProps<WrapperProps>) => {
  if (!condition || !Wrapper) return children

  const props = { ...wrapperProps, children } as WrapperProps
  return <Wrapper {...props} />
}
